export const NCB_CONFIG = {
  instance: '55954_friendsfinder',
  secretKey: 'f2831bd8daa887dabdf3886824abd02c91f5cbc69c86c12a9a4b6dbee83e',
  authUrl: 'https://app.nocodebackend.com/api/user-auth',
  dataUrl: 'https://app.nocodebackend.com/api/data',
};

// LOGIN / SIGNUP
export async function authFetch(path, options = {}) {
  return fetch(`${NCB_CONFIG.authUrl}/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
      'X-Database-Instance': NCB_CONFIG.instance,
      ...options.headers,
    }
  });
}

// ALL DATA CRUD MUST USE SECRET_KEY
export async function writeFetch(path, options = {}) {
  const separator = path.includes('?') ? '&' : '?';
  const url = `${NCB_CONFIG.dataUrl}/${path}${separator}Instance=${NCB_CONFIG.instance}`;

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
      'X-Database-Instance': NCB_CONFIG.instance,
      ...options.headers,
    }
  });

  const data = await res.json();

  if (!res.ok || data?.status === 'error' || data?.status === 'failed') {
    const errorMsg = data?.message || data?.error || `Request failed with status ${res.status}`;
    // If it's a 404 on read, return empty array instead of throwing
    if (res.status === 404 && path.startsWith('read')) return { data: [] };
    console.error("NCB API Error:", errorMsg, data);
    throw new Error(errorMsg);
  }

  return data;
}

export async function signIn(email, password) {
  const res = await authFetch('sign-in/email', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'Login failed');
  }

  const data = await res.json();

  if (data.token && data.user) {
    localStorage.setItem('ncb_token', data.token);
    // Add full_name to metadata if it doesn't exist
    data.user.user_metadata = { full_name: data.user.name || email.split('@')[0] };
    localStorage.setItem('ncb_user', JSON.stringify(data.user));
    return data;
  }

  throw new Error('Login failed');
}

export async function signUp(email, password, name) {
  const res = await authFetch('sign-up/email', {
    method: 'POST',
    body: JSON.stringify({ email, password, name })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'Signup failed');
  }

  const data = await res.json();

  if (data.token && data.user) {
    localStorage.setItem('ncb_token', data.token);
    data.user.user_metadata = { full_name: data.user.name || name };
    localStorage.setItem('ncb_user', JSON.stringify(data.user));
    return data;
  }

  throw new Error('Signup failed');
}

export async function requestPasswordReset(email) {
  const res = await authFetch('request-password-reset', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'Failed to request password reset');
  }

  return await res.json();
}

export async function confirmPasswordReset(token, newPassword) {
  const res = await authFetch('confirm-password-reset', {
    method: 'POST',
    body: JSON.stringify({ token, newPassword })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'Failed to reset password');
  }

  return await res.json();
}

export async function requestEmailVerification(email) {
  const res = await authFetch('request-verification', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'Failed to request verification');
  }

  return await res.json();
}

export function getSession() {
  const stored = localStorage.getItem('ncb_user');
  return stored ? JSON.parse(stored) : null;
}

export function signOut() {
  localStorage.removeItem('ncb_token');
  localStorage.removeItem('ncb_user');
  window.dispatchEvent(new Event('auth-state-change'));
}